import {EnvironmentImageRequestParams} from "../../../models/image/environment-image-request-params";

export class SponsoredCupSelectedImageRequestParams extends EnvironmentImageRequestParams {
  constructor(width: Number, height: Number) {
    super({width, height});

    this._resourceName = `/assets/Cup_Icon_-_Selected`;
    this.ratio = 3;
  }
}
